<template>
  <eg-modal
    id="create-workspace-integration-modal"
    :title="
      currentStepConfig?.headerTitle ? currentStepConfig.headerTitle : null
    "
    :closable="false"
    :value="true"
    size="medium"
    style="z-index: var(--layout-z-index-modal)"
    @input="$emit('update:isShown', $event)"
  >
    <component
      :is="currentStepConfig.component"
      v-if="currentStepConfig"
      v-model="formData"
    />
    <template #modal-footer>
      <eg-button type="secondary" @click="onClose">{{
        $t("common.close")
      }}</eg-button>
      <component
        :is="currentStepConfig.action.component"
        v-if="currentStepConfig.action.component"
        v-bind="currentStepConfig.action.props"
        :disabled="
          typeof currentStepConfig.action.disabled === 'function'
            ? currentStepConfig.action.disabled(formData)
            : currentStepConfig.action.disabled
        "
        @done="handleOnDone($event, currentStepConfig)"
      />
      <eg-button
        v-else
        :type="currentStepConfig.action.type"
        :disabled="
          typeof currentStepConfig.action.disabled === 'function'
            ? currentStepConfig.action.disabled(formData)
            : currentStepConfig.action.disabled
        "
        @click="handleAction(currentStepConfig.action)"
      >
        {{ currentStepConfig.action.label }}
      </eg-button>
    </template>
  </eg-modal>
</template>

<script>
import googleSteps from "../googleClassroom/googleClassroomConfig.js";
import canvasSteps from "../canvas/stepsConfig.js";
import schoologySteps from "../schoology/schoologyConfig";
import { LMS_PROVIDERS } from "@/constants";
import {
  actionResultType,
  actionType,
} from "@/views/dashboard/workspace-integration/actionType";
import { getUser } from "@/api";
import { mergeUserData } from "@/utils/userUtils";

export default {
  name: "CreateWorkspaceIntegrationModal",
  components: {},
  props: {
    platformKey: { type: String, required: true },
    visible: { type: Boolean, default: false },
  },

  data() {
    return {
      isLoading: true,
      isSaving: false,
      stepsConfig: [],
      currentStep: 0,
      formData: {},
      providers: LMS_PROVIDERS,
    };
  },

  computed: {
    currentStepConfig() {
      return this.stepsConfig[this.currentStep] || null;
    },
    isLastStep() {
      return this.currentStep === this.stepsConfig.length - 1;
    },
  },

  watch: {
    platformKey: {
      immediate: true,
      handler(newPlatformKey) {
        this.initStep(newPlatformKey);
      },
    },
    currentStepConfig() {
      return this.stepsConfig[this.currentStep] || null;
    },
    isLastStep() {
      return this.currentStep === this.stepsConfig.length - 1;
    },
  },

  methods: {
    initStep(platformKey) {
      const t = this.$t.bind(this);
      const configs = {
        [this.providers.google.key]: googleSteps(t),
        [this.providers.googleClassroom.key]: googleSteps(t),
        [this.providers.canvas.key]: canvasSteps(t),
        [this.providers.schoology.key]: schoologySteps(t),
      };

      this.stepsConfig = configs[platformKey] || [];
      this.currentStep = 0;
    },
    async updateUserData() {
      const { data } = await getUser("me");
      const userData = mergeUserData(this, data);
      await this.$store.dispatch("setUser", userData);
    },

    async handleOnDone(result) {
      await this.updateUserData();
      this.$emit("onSuccess", result.gid);
      this.onClose();
    },

    async handleAction(action) {
      try {
        if (action.actionType === actionType.next) {
          this.currentStep++;
        } else if (action.actionType === actionType.submit) {
          const result = await action.onSubmit(this.formData);
          if (result?.type === actionResultType.REDIRECT) {
            // should not handle result in case redirection (e.g. Schoology integration)
            return;
          }
          await this.updateUserData();
          this.$emit("onSuccess", result.id);
          this.onClose();
        }
      } catch (e) {
        // API error is handled in the api/errorHandler.js
        if (!e.isAxiosError) {
          this.$showToastError(this.$t("imports.errorOccurred"));
        }
      }
    },
    onClose() {
      this.$egModal.hide("create-workspace-integration-modal");
    },
  },
};
</script>
